import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ENotificationType, Notification } from 'Shared/components/Notification';
const ErrorMessage = ({ title = 'Attention', message, className, }) => (_jsx(Notification, Object.assign({ showNotificationIcon: true, showCloseIcon: false, title: title, type: ENotificationType.Info, className: className }, { children: message }), void 0));
export default memo(ErrorMessage);
